import React from 'react';

import { Block } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import Defaults from '../layout/Defaults.jsx';
import HeaderText from './HeaderText.jsx';
import Kit from '../layout/Kit.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';

// region PAGE TITLE V1

function _PageTitleV1Component(props) {
    let style = {};
    if (props.blockConfig && props.blockConfig.container) {
        Block.mapStyleConfigProps(style, props.blockConfig.container);
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    if (layoutStyles.containerStyle && layoutStyles.containerStyle.maxWidth) {
        layoutStyles.containerStyle.width = '100%';
    }
    let className = 'cont--page__title layout__page__header';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className={className} style={layoutStyles.style}>
                    <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const PageTitleV1Component = Token.withContentTokenParsing(_PageTitleV1Component, { headerConversionMap: { [Token.Title]: 'h1' } }, (props, keyword, options) => Token.parsing.pages(props.pageData || props.data, keyword, options));
const PageTitleTokens = () => {
    return [
        { display: 'Page Title', token: Token.Title }
    ];
}
const PageTitleV1 = { Component: PageTitleV1Component, Tokens: PageTitleTokens };

// region PAGE TITLE V2 (-- DEPRECATED Use `PageTitleV1` --)

function PageTitleV2Component(props) {
    return <HeaderText.TokenizedComponent {...props} defaultDesign={Defaults.Block[Name.Block.PageTitleV2]} type={Kit.Type.CustomPage} />
}
const PageTitleV2 = { Component: PageTitleV2Component, Tokens: PageTitleTokens };

export {
    PageTitleV1,

    // DEPRECATED
    PageTitleV2
}